import { baseGatewayApiV1 } from '@verantos-dev/app-state-base';
import { getCohortsPath } from '@verantos-dev/core-constants';
import {
  CohortBuilderDefinitionLegacy,
  CohortTranslation,
  SelectStatementType,
} from '@verantos-dev/types-cohorts';
import { ObjectResponse } from '@verantos-dev/types-common';

export const cohortsTranslationApiSlice = baseGatewayApiV1.enhanceEndpoints({}).injectEndpoints({
  endpoints: (builder) => ({
    generateSQLTranslation: builder.mutation<
      ObjectResponse<CohortTranslation>,
      {
        projectId: string;
        cohortId: string;
        selectStmtType: SelectStatementType;
        cohortJsonDsl: CohortBuilderDefinitionLegacy;
      }
    >({
      query: ({ cohortId, projectId, selectStmtType, cohortJsonDsl }) => ({
        url: `${getCohortsPath(projectId)}/${cohortId}/translate`,
        method: 'POST',
        body: { selectStmtType, cohortJsonDsl },
      }),
    }),
    validateAVLogicTranslation: builder.mutation<
      ObjectResponse<CohortTranslation>,
      {
        projectId: string;
        cohortId: string;
        cohortJsonDsl: CohortBuilderDefinitionLegacy;
        startingCohortNode: string;
      }
    >({
      query: ({ cohortId, projectId, cohortJsonDsl, startingCohortNode }) => ({
        url: `${getCohortsPath(projectId)}/${cohortId}/translate`,
        method: 'POST',
        body: {
          selectStmtType: SelectStatementType.ALL,
          cohortJsonDsl,
          startingCohortNode,
          pickComponent: { component: 'LOGIC' },
        },
      }),
    }),
  }),
});

export const { useGenerateSQLTranslationMutation, useValidateAVLogicTranslationMutation } =
  cohortsTranslationApiSlice;
